<template>
  <div>
    <list
      row-key="RoleId"
      ref="list"
      unit="菜单"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="角色名称">
          <el-input size="mini" v-model="params.RoleName" placeholder="请输入角色名称" clearable />
        </el-form-item>
        <!-- <el-form-item label="角色类型">
          <el-select size="mini" v-model="params.RoleType" placeholder="请选择角色类型" clearable>
            <el-option label="平台" :value="0"></el-option>
            <el-option label="商家" :value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
         <!-- <el-table-column prop="RoleType" align="center" label="角色类型" width="80">
          <template slot-scope="{row}">
           <span>{{row.RoleType==0?"平台":"商家"}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="RoleName" label="角色名称" :width="$store.state.isMB?'100px':''" />
        <el-table-column prop="Remark" label="描述" :width="$store.state.isMB?'100px':''" />
        <el-table-column prop="Status" align="center" label="状态" width="80">
          <template slot-scope="{row}">
            <el-tag size="mini" type="success" v-if="row.Status">启用</el-tag>
            <el-tag size="mini" type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import list from "@/components/common/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sy/role").default,
      params: {
        RoleName: "",
        Status: null,
        RoleType: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>